<wre-google-tag-manager></wre-google-tag-manager>
<router-outlet (activate)="this.adminService.pageIsLoading = false;"></router-outlet>
